import { Stack, Typography } from '@mui/material';
import PWDKTabs from 'components/PWDKTabs';
import React, { useMemo } from 'react';
import MemberList from './component/MemberList';

const TribeMember = ({ tribeMembers, refetch, activeTab, setActiveTab }) => {
  const tabMenus = useMemo(() => {
    const requestTribeMemberCount = tribeMembers.filter(
      ({ approved }) => !approved,
    )?.length;
    return [
      { label: 'Member', value: 'member' },
      {
        label: 'Request',
        value: 'request',
        badge: (
          <Typography
            display="flex"
            alignItems="center"
            justifyContent="center"
            backgroundColor="error500.main"
            padding={0.5}
            borderRadius="100%"
            typography={{ md: 'caption1', xs: 'metatag1' }}
            width={{ md: '24px', xs: '20px' }}
            height={{ md: '24px', xs: '20px' }}
            color="error300.main"
          >
            {requestTribeMemberCount}
          </Typography>
        ),
      },
    ];
  }, [tribeMembers]);

  return (
    <Stack
      p={3}
      sx={{ backgroundColor: 'neutralWhite.main', borderRadius: '8px' }}
    >
      <Typography
        typography={{ xs: 'subheading3', md: 'subheading2' }}
        color="primaryBrandPurwadhika.main"
      >
        Tribe Members
      </Typography>

      <PWDKTabs
        active={activeTab}
        onChange={(e, value) => setActiveTab(value)}
        tabMenus={tabMenus}
      />
      <MemberList
        tribeMembers={tribeMembers}
        activeTab={activeTab}
        refetch={refetch}
      />
    </Stack>
  );
};

export default TribeMember;
